import { GetTokenSilentlyOptions, RedirectLoginOptions } from "@auth0/auth0-spa-js";

export const DEFAULT_LOGIN_OPTIONS : RedirectLoginOptions<any> = {
      authorizationParams: {
        audience: process.env.REACT_APP_AUDIENCE,
        scope: process.env.REACT_APP_SCOPE,
        prompt: "login",
      },
      appState: { returnTo: window.location.pathname + window.location.search }
}

export const DEFAULT_SILENT_TOKEN_OPTIONS_INTELLISIGHT_API: GetTokenSilentlyOptions = {
  authorizationParams: {
    audience: process.env.REACT_APP_AUDIENCE,
    scope: process.env.REACT_APP_SCOPE,
  },
};
